<template>
  <div id="map" style="height: 100%;width: 100%;border-radius: 10px;background-color: white;position: relative">
    <div style="position: absolute;top: 8px;left: 8px;color: #333333;font-size: 18px;font-weight: bold;">设备地区分布（前五省）</div>
  </div>
</template>

<script>
  import axios from 'axios'
  import G2 from '@antv/g2';
  import { View } from '@antv/data-set';
  export default {
    name: 'Map',
    mounted() {
      axios.get(this.$store.getters.getApiValue+'/china-provinces.geo.json')
        .then((response) => {
          var data = response.data;
          axios.get(this.$store.getters.getApiValue+'/srsScreen/deviceDistribution.do')
            .then((res) => {
              var data1 = res.data;
              if(data1.status == "200"){
                this.initDeviceLocalDiv(data,data1.data)
              }else{
                this.$message.error(data.message);
              }
            }).catch((error) => {
            this.$message.error("系统异常，请与管理员联系!");
            console.log(error);
          });
        }).catch((error) => {
        console.log(error);
        this.$message.error("系统异常!请与管理员联系!");
      });
    },
    methods: {
      initDeviceLocalDiv(mapdata,userData){
        this.deviceChart = new G2.Chart({
          container: this.$el,
          forceFit: true,
          height: this.$el.clientHeight,
          width: this.$el.clientWidth,
          padding: [20,160,0,0]
        });
        this.deviceChart.tooltip({
          showTitle: false
        });
        // 同步度量
        this.deviceChart.scale({
          longitude: {
            sync: true
          },
          latitude: {
            sync: true
          }
        });
        this.deviceChart.axis(false);
        this.deviceChart.legend('name', {
          position: 'right-center'
        });

        // 绘制世界地图背景
        var worldMap = new View('back').source(mapdata, {
          type: 'GeoJSON'
        });
        var worldMapView = this.deviceChart.view();
        worldMapView.source(worldMap);
        worldMapView.tooltip(false);
        worldMapView.polygon().position('longitude*latitude').style({
          fill: '#fff',
          stroke: '#ccc',
          lineWidth: 1
        });

        var userDv = new View().source(userData).transform({
          geoDataView: worldMap,
          field: 'name',
          type: 'geo.region',
          as: ['longitude', 'latitude']
        }).transform({
          type: 'map',
          callback: function callback(obj) {
            obj.trend = "第"+obj.rank+"名";
            obj.name = obj.name+"(销量:"+obj.value+"台)";
            obj.firstChild = "无";
            obj.secondChild = "无";
            obj.thirdChild = "无";
            for(var i = 0;i < obj.cityDistributionVOs.length;i++){
              if(obj.cityDistributionVOs[i].rank == '1'){
                obj.firstChild = obj.cityDistributionVOs[i].name+"(销量:"+obj.cityDistributionVOs[i].value+"台)";
              }
              if(obj.cityDistributionVOs[i].rank == '2'){
                obj.secondChild = obj.cityDistributionVOs[i].name+"(销量:"+obj.cityDistributionVOs[i].value+"台)";
              }
              if(obj.cityDistributionVOs[i].rank == '3'){
                obj.thirdChild = obj.cityDistributionVOs[i].name+"(销量:"+obj.cityDistributionVOs[i].value+"台)";
              }
            }
            return obj;
          }
        });
        var userView = this.deviceChart.view();
        userView.source(userDv, {
          'trend': {
            alias: '销售排名'
          },
          'name': {
            alias: '销售前五省市'
          },
          firstChild:{
            alias:'销售第一城市'
          },
          secondChild:{
            alias:'销售第二城市'
          },
          thirdChild:{
            alias:'销售第三城市'
          }
        });
        userView.polygon().position('longitude*latitude').color('name', ['#0099FB', '#A0D911', '#FADB14', '#FA541C', '#EB2F96'])
          .tooltip('name*trend*firstChild*secondChild*thirdChild').animate({
          leave: {
            animation: 'fadeOut'
          }
        });
        this.deviceChart.render();
        this.isFirstInit = false;
      },
    }
  }
</script>

<style scoped>

</style>